import { Navigate, type RouteObject } from 'react-router';
import { ModuleRoute } from '@/components/guards';

/** Rotas deste módulo, montadas dentro do layout do painel (caminhos relativos). */
export const checkoutRoutes: RouteObject[] = [
  {
    path: 'checkout',
    element: <ModuleRoute module="checkout" permission="orders:read" />,
    children: [
      // Retorno do OAuth do Melhor Envio (redirect_uri da API e links de e-mail).
      { path: 'frete/conectar', lazy: async () => ({ Component: (await import('./shipping')).ShippingConnectCallbackPage }) },
      {
        lazy: async () => ({ Component: (await import('./layout')).CheckoutLayout }),
        children: [
          { index: true, element: <Navigate to="/checkout/configuracoes" replace /> },
          { path: 'configuracoes', lazy: async () => ({ Component: (await import('./settings')).CheckoutSettingsPage }) },
          {
            path: 'recebimento',
            element: <ModuleRoute permission="checkout:payment-account" />,
            children: [{ index: true, lazy: async () => ({ Component: (await import('./payment-account')).PaymentAccountPage }) }],
          },
          { path: 'frete', lazy: async () => ({ Component: (await import('./shipping')).ShippingPage }) },
          { path: 'cupons', lazy: async () => ({ Component: (await import('./coupons')).CouponsPage }) },
        ],
      },
    ],
  },
];
